import { Model } from '@/models/Model'
import Property from '@/decorators/Property'
import { ToManyRelation } from 'coloquent/dist/relation/ToManyRelation'
import { HopperMeasurement } from '@/models/HopperMeasurement'
import TransshipmentDirection from '@/types/TransshipmentDirection'

export class HopperMeasurementsReport extends Model {
	protected jsonApiType = 'hopperMeasurementsReports'

	@Property()
	public fullWhenMeasured!: boolean

	@Property()
	public transshipmentDirection!: TransshipmentDirection

	public measurements(): ToManyRelation {
		return this.hasMany(HopperMeasurement, 'measurements')
	}

	public getMeasurements(): Array<HopperMeasurement> {
		return this.relation('measurements') || []
	}

	public setMeasurements(measurements: Array<HopperMeasurement>) {
		this.setRelation('measurements', measurements)
	}
}
